"use strict";
var zip_1 = require('../operator/zip');
exports.zip = zip_1.zipStatic;
//# sourceMappingURL=zip.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/observable/zip.js
 ** module id = 360
 ** module chunks = 9
 **/